<!--<div  *ngIf="!initialLoaing; else loading" >-->

<div class="streams-page"  *ngIf="stream" > 
    <h5>Захист </h5>
 
        

</div> 
     